import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Registration } from '../../../../schemas'
import { Col, Container, ErrorMessage, FormInput } from '../../../basics'
import { FormRow } from '../FormRow'

const translateNamespace = 'components.InvoiceAddresseeForm'

export const InvoiceAddresseeForm = () => {
  const { t } = useTranslation()
  const {
    control,
    formState: { errors },
  } = useFormContext<Registration>()

  return (
    <Container>
      <FormRow>
        <Col>
          <FormInput
            control={control}
            name="invoiceAddressee"
            required
            inputMode="text"
            label={t(`${translateNamespace}.label`)}
            placeholder={t(`${translateNamespace}.placeholder`)}
          />
          <ErrorMessage errors={errors} name="invoiceAddressee" />
        </Col>
      </FormRow>
    </Container>
  )
}
